import * as React from 'react';
import { Form, useFormikContext } from 'formik';
import styled from 'styled-components';
import { Panel } from '@rtkwlf/ui';
import { InformationInputs } from './form/InformationInputs';
import { ShippingInputs } from './form/ShippingInputs';
import { Summary } from './form/Summary';
import { SensorFormValues } from './constants';
import { FooterButtons } from '../../../FooterButtons';
import { useBeforeUnloadConfirmation } from '../../../hooks/useBeforeUnloadConfirmation';
import { RouterPrompt } from '../../../../../widgets/RouterPrompt';
import { IPConfigFormInputs } from '../../forms/IPConfigFormInputs';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const LeftPanel = styled(Panel)`
  width: 700px;
  && {
    margin-left: 0;
    padding: 3rem;
  }
`;

export const FixedRightPanel = styled(Panel)`
  position: fixed;
  && {
    margin-left: 750px;
    padding: 3rem;
  }
  max-width: 470px;
`;

export const PanelTitle = styled.h3`
  margin-bottom: 2rem;
`;

type Props = {
  showSaveAndAdd?: boolean;
  recommendedModel?: string;
  view?: string;
};

export const OnboardingSensorForm: React.FunctionComponent<Props> = ({
  showSaveAndAdd,
  recommendedModel,
  view,
}) => {
  useBeforeUnloadConfirmation();

  const { values } = useFormikContext<SensorFormValues>();

  // Formik is causing the page to scroll to the bottom on mount for some reason
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Form>
      <RouterPrompt />
      <Container>
        <LeftPanel>
          <InformationInputs
            deviceType="Sensor"
            recommendedModel={recommendedModel}
          />

          <IPConfigFormInputs />
          <ShippingInputs />
          <FooterButtons showSaveAndAdd={!!showSaveAndAdd} view={view} />
        </LeftPanel>

        <FixedRightPanel>
          <PanelTitle>Summary</PanelTitle>
          <Summary
            device={values}
            isInfoSet={!!(values.model && values.name)}
          />
        </FixedRightPanel>
      </Container>
    </Form>
  );
};
